import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import { Button } from 'components/buttons';
import Link from '../../Link';

// ⏩ Replacement for makeStyles
export const Paper = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(6),
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center'
}));

export const Form = styled('form')(({ theme }) => ({
  width: '100%', // Fix IE 11 issue
  marginTop: theme.spacing(1)
}));

export const SubmitButton = styled(Button)(({ theme }) => ({
  margin: theme.spacing(3, 0, 2)
}));

export const CancelButton = styled(Button)(({ theme }) => ({
  margin: theme.spacing(3, 3, 2)
}));

export const Heading = styled('h2')(() => ({
  width: '100%',
  color: '#003049',
  textAlign: 'center'
}));

export const NavLinkActive = styled('span')(() => ({
  color: '#206AF5',
  cursor: 'pointer'
}));

export const NavLinkInactive = styled('span')(() => ({
  color: '#C8C8C8',
  cursor: 'pointer'
}));

export const Inactive = styled('span')(() => ({
  color: '#CCCCCC'
}));

export const TextContainer = styled('div')(() => ({
  height: '50vh',
  overflowY: 'scroll'
}));

export const Text = styled('span')(() => ({
  color: '#003049'
}));

export const Pointer = styled('span')(() => ({
  cursor: 'pointer'
}));

// Form footer
export const FormFooter = styled('div')(() => ({
  display: 'flex',
  alignItems: 'flex-end',
  flexDirection: 'row',
  marginTop: 5,
  justifyContent: 'flex-end'
}));

export const TermsHeader = styled('div')(() => ({
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  flexWrap: 'wrap',
  flexFlow: 'row',
  justifyContent: 'left',
  marginBottom: 25
}));

export const TermsHeaderText = styled('div')(() => ({
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  flexWrap: 'wrap',
  flexFlow: 'column',
  justifyContent: 'center'
}));

export const NDAText = styled('div')(({ theme }) => ({
  fontWeight: theme.fontWeight.light,
  whiteSpace: 'pre-wrap',
}));

export const Title = styled('h3')(({ theme }) => ({
  fontSize: theme.fontSize.large, // or theme.typography.h6.fontSize if you prefer consistency
  fontWeight: theme.fontWeight.light,
  margin: 0,
}));

export const DownloadLink = styled(Link)(({ theme }) => ({
  fontSize: theme.fontSize.xsmall,
}));

export const DownloadText = styled('span')(({ theme }) => ({
  fontWeight: theme.fontWeight.bold,
  marginLeft: theme.spacing(1),
  textTransform: 'uppercase',
}));

export const ActionItem = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  '.MuiFormControlLabel-root': {
    marginLeft: 0,
    marginRight: 0
  }
}));

export const NDAFooter = styled('div')(({ theme, wrap, justify }) => ({
  display: 'flex',
  alignItems: 'center',
  flexGrow: 1,
  flexWrap: wrap || 'wrap',
  marginBottom: theme.spacing(-1.25),
  ...(justify ? { justifyContent: justify } : {}),
  '@media (max-width:650px)': {
    justifyContent: 'center'
  }
}));

export const NDAViewer = styled('div')(({ theme }) => ({
  margin: `${theme.spacing(2)} 0`,
  minHeight: 370
}));

export const NDAContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  minHeight: '100%',
  width: '100%',
  // Flex adjustments for child NDAFooter/NDAViewer
  '& > div': {
    '&:first-of-type': {
      flexGrow: 0
    },
    '&:nth-of-type(2)': {
      flexGrow: 1
    }
  }
}));
